<template>
  <div class="flex flex-col gap-y-2">
    <h4>{{ $t('SelectMobileNumber') }}</h4>
    <Field
      :rules="(value) => requiredRule(value, 'SELECT_PHONE')"
      name="registerdMobileNumberId"
      v-slot="{ value, errors, handleChange, resetField }"
    >
      <div class="w-full flex flex-wrap gap-3">
        <button
          :key="m.id"
          :class="[
            value == m.value
              ? 'bg-primary text-white border-primary-700'
              : 'bg-brand-gray-300 border-brand-gray-600'
          ]"
          class="px-2.5 py-0.5 rounded-lg border ltr:font-sans text-sm"
          v-for="m in parsedPhoneNumbers"
          @click.prevent="() => (value === m.value ? resetField() : handleChange(m.value))"
        >
          {{ m.label }}
        </button>
      </div>
      <div class="flex flex-col gap-y-1 text-xs ltr:font-sans">
        <span :key="err" v-for="err in errors" class="text-brand-red">
          {{ $t(err) }}
        </span>
      </div>
    </Field>
  </div>
</template>

<script setup>
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const i18n = useI18n()

const props = defineProps({
  registeredMobileNumbers: {
    type: Array,
    required: true
  }
})

const parsedPhoneNumbers = computed(() => {
  return props.registeredMobileNumbers.map((r) => {
    return {
      value: r.id,
      label: r.mobileNumber
    }
  })
})

function requiredRule(value, errorMessage = 'INVALID_REQUIRED') {
  if (!value || !`${value}`.trim()) {
    return i18n.t(errorMessage)
  }

  return true
}
</script>

<style lang="scss" scoped></style>
